import { ADD_ITEM_TO_CART_API, generateBFFUrl } from '@/configs/apiEndPoints';
import { ASSET_ID_QUERY_PARAM } from '@/configs/serviceConstants';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { CartData } from '@/types/cart';

export const addItemToCart = async (
  assetId: string,
  productVariantId: string,
  serverCookie?: any,
): Promise<CartData> => {
  const cartData = await axiosInstance
    .post(
      generateBFFUrl(`${ADD_ITEM_TO_CART_API}?${ASSET_ID_QUERY_PARAM}=${assetId}`),
      {
        product_variant_id: productVariantId,
      },
      {
        headers: generateHttpHeaders(serverCookie),
      },
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err: any) => {
      const { response } = err;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return cartData;
};

export const addAmcPlanToCart = async (
  assetId: string,
  productVariantId: string,
  serverCookie?: any,
): Promise<CartData> => {
  try {
    return await axiosInstance.post(
      generateBFFUrl(`${ADD_ITEM_TO_CART_API}?${ASSET_ID_QUERY_PARAM}=${assetId}`),
      {
        product_variant_id: productVariantId,
      },
      {
        headers: generateHttpHeaders(serverCookie),
      },
    );
  } catch (err: any) {
    const { response } = err;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
